// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.previewParent {
  border: 1px solid gray;
  height: calc(100vh - 46px);
  overflow-y: scroll;
}`, "",{"version":3,"sources":["webpack://./src/app/common/document-summary/file-preview/file-preview.component.scss"],"names":[],"mappings":"AAAA;EACI,sBAAA;EACA,0BAAA;EACA,kBAAA;AACJ","sourcesContent":[".previewParent{\r\n    border: 1px solid gray;\r\n    height: calc(100vh - 46px);\r\n    overflow-y: scroll;\r\n  }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
